interface CategoryLink {
  label: string
  href?: string
}

interface CategoryLinkGroupProps {
  /** Category header text (displayed uppercase) */
  header: string
  /** List of navigation links */
  links: CategoryLink[]
  /** Additional classes on the wrapper */
  className?: string
}

export function CategoryLinkGroup({
  header,
  links,
  className = "",
}: CategoryLinkGroupProps) {
  return (
    <div className={className}>
      <h3 className="text-xs font-bold text-[#ff9951] uppercase tracking-widest mb-4">
        {header}
      </h3>
      <ul className="space-y-2">
        {links.map((link, i) => (
          <li key={i}>
            {link.href ? (
              <a
                href={link.href}
                className="text-sm text-gray-500 hover:text-[#0469f0] hover:scale-[1.02] inline-block transition-all"
              >
                {link.label}
              </a>
            ) : (
              <span className="text-sm text-gray-500">{link.label}</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}
